import { useState, useEffect } from "react"
import { Button, Space, Table, message, Modal } from "antd"
import { deleteApiEndpoint } from "../../api/api_endpoints"
import EndpointForm from "./EndpointForm.js"

export const AddApiEndpoints = ({ serviceId, apiDetails, onClose, fetchApiCounts  }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [listingSource, setListingSource] = useState([])
  const [isFormVisible, setIsFormVisible] = useState(false)
  const { confirm } = Modal
  useEffect(() => {
    setListingSource(apiDetails)
  }, [apiDetails])

  useEffect(() => {
    fetchApiCounts()
  }, [fetchApiCounts])
  const handleDeleteApi = async (apiId) => {
    setIsLoading(true)
    try {
      await deleteApiEndpoint(apiId)
      setListingSource((prevState) => prevState.filter((api) => api._id !== apiId))
      message.success("API deleted successfully")
    } catch (error) {
      console.error("Error deleting API:", error)
      message.error("Failed to delete API")
    } finally {
      setIsLoading(false)
    }
  }
  const handleDeleteClick = (appName, apiId) => {
    confirm({
      title: "Are you sure you want to delete this api?",
      content: `You are deleting ${appName}.`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await deleteApiEndpoint(apiId)
          setListingSource((prevState) => prevState.filter((api) => api._id !== apiId))
          message.success("API deleted successfully")
          fetchApiCounts() // Add this line to update API counts after deletion
        } catch (error) {
          console.error("Error deleting service:", error)
          message.error("Failed to delete app. Please try again.")
        }
      },
      onCancel() {},
    })
  }
  const handleFormSubmit = async (payload) => {
    setIsFormVisible(false)
  }

  const columns = [
    {
            title : 'API Name',
            dataIndex : 'api_name',
            key : 'api_name',
            align : 'center'
    },
    {
            title : 'API Endpoint',
            dataIndex : 'api_endpoint',
            key : 'api_endpoint',
            align : 'center'
    },
    {
            title : 'Method',
            dataIndex : 'method',
            key : 'method',
            align : 'center'
    },
    {
            title : 'Description',
            dataIndex : 'description',
            key : 'description',
            align : 'center'
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleDeleteClick(record.api_name,record._id)}>Delete API</Button>
        </Space>
      ),
    },
  ]

  useEffect(() => {
    fetchApiCounts()
  }, [listingSource, fetchApiCounts])

  return (
    <div style={{ margin: "20px" }}>
      <div className="large-icon-container add-api-container">
        <span>API Details</span>
        <Button onClick={onClose}>Back</Button>
      </div>

      <div style={{ marginBottom: 16 }}>
        {/* <Button type="primary" onClick={() => setIsFormVisible(true)}>
          Add New API
        </Button> */}
      </div>

      <Table
        loading={isLoading}
        bordered={true}
        columns={columns}
        dataSource={listingSource}
        pagination={true}
        scroll={{ y: 400 }}
      />

      <EndpointForm
        isVisible={isFormVisible}
        onClose={() => setIsFormVisible(false)}
        onSubmit={handleFormSubmit}
        serviceId={serviceId}
      />
    </div>
  )
}

export default AddApiEndpoints

